import Debug from 'debug';
import { QuizPlayerStateMachineAbstractState, QuizStartOptions,
         QuizPlayerStateMachineCommonEvents } from './quiz-player-state-machine-state'
import { QuizPlayerStateMachineData } from '../data';

const debug = Debug('quiz-player-intro-state')

interface Events extends QuizPlayerStateMachineCommonEvents {
  onStart: (options: QuizStartOptions) => void
}

export class QuizPlayerIntroState extends QuizPlayerStateMachineAbstractState<Events> {

  public readonly name = 'intro'

  constructor(
    private data: QuizPlayerStateMachineData) {

    super()
  }

  enter() {
    debug('enter')
    this.data.goToIntro()
  }

  exit() {
    debug('exit')
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.endCancel()
  }

  startQuiz(options: QuizStartOptions) {

    switch (options.mode) {
      case 'practice':
        if (!this.data.hasPractice) {
          debug('practice mode is not allowed')
          return
        }
        break
      case 'exam':
        if (!this.data.hasExam) {
          debug('exam mode is not allowed')
          return
        }

        break
    }

    this.triggerEvent(events => events.onStart(options))
  }
}
